export default "__VITE_ASSET__b540f0dc__"